import { useCallback, useState } from "react";

import { calculateZoomLevelForBounds } from "utils/map";

const useInitialZoom = (bounds, { enabled = true, defaultZoom, defaultCenter }) => {
  const [zoom, setZoom] = useState(defaultZoom);
  const [center, setCenter] = useState(defaultCenter);

  const setInitialZoom = useCallback(
    (ref) => {
      if (!enabled || !ref || !bounds) return;

      const element = ref.getDiv();
      setZoom(
        calculateZoomLevelForBounds(bounds, {
          height: element.clientHeight,
          width: element.clientWidth,
        }),
      );

      // May want this to be optional?
      setCenter(bounds.getCenter());
    },
    [bounds, enabled],
  );
  return {
    zoom,
    center,
    setInitialZoom,
  };
};

export default useInitialZoom;
